module.exports = __webpack_public_path__ + "static/media/publishing_image4.156c685a.webp";